(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function finish(content, details, closing) {
      content.style.height = '';
      content.style.transition = '';
      if (closing) details.open = false;
      details.classList.remove('is-animating', 'hm-acc-closing');
      // Si se pidió cerrarla mientras terminaba de abrirse (otra fila se abrió justo después), se cierra ahora.
      if (!closing && details._hmCloseAfter) {
        details._hmCloseAfter = false;
        closePanel(details, content);
      }
    }

    function onEnd(content, details, closing) {
      return function (event) {
        if (event.target !== content || event.propertyName !== 'height') return;
        content.removeEventListener('transitionend', content._hmAccordEnd);
        finish(content, details, closing);
      };
    }

    function openPanel(details, content) {
      details.classList.add('is-animating');
      details.open = true;
      content.style.height = '0px';
      content.style.transition = 'none';
      void content.offsetHeight;
      content.style.transition = 'height 0.4s ease';
      content.style.height = content.scrollHeight + 'px';
      content._hmAccordEnd = onEnd(content, details, false);
      content.addEventListener('transitionend', content._hmAccordEnd);
    }

    function closePanel(details, content) {
      details.classList.add('is-animating', 'hm-acc-closing');
      content.style.height = content.scrollHeight + 'px';
      content.style.transition = 'none';
      void content.offsetHeight;
      content.style.transition = 'height 0.4s ease';
      content.style.height = '0px';
      content._hmAccordEnd = onEnd(content, details, true);
      content.addEventListener('transitionend', content._hmAccordEnd);
    }

    // Solo una fila abierta a la vez: al abrir una, las demás de la sección se pliegan con su animación.
    function closeSiblings(details) {
      var root = details.closest('.shopify-section') || document;
      root.querySelectorAll('.collapsible-content details').forEach(function (other) {
        if (other === details) return;
        var panel = other.querySelector('.accordion__content');
        if (!panel) return;
        if (other.classList.contains('is-animating')) {
          if (other.open) other._hmCloseAfter = true;
          return;
        }
        if (other.open) closePanel(other, panel);
      });
    }

    function bind(details) {
      if (details.dataset.hmAccordBound) return;
      details.dataset.hmAccordBound = 'true';
      var summary = details.querySelector('summary');
      var content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      summary.addEventListener('click', function (event) {
        if (reduced) return;
        event.preventDefault();
        if (details.classList.contains('is-animating')) return;
        if (details.open) {
          closePanel(details, content);
        } else {
          closeSiblings(details);
          openPanel(details, content);
        }
      });
    }

    function init(root) {
      (root || document).querySelectorAll('.collapsible-content details').forEach(bind);
    }

    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    // Con «reducir movimiento» la fila se abre sin animación: las demás se pliegan igual.
    document.addEventListener(
      'toggle',
      function (event) {
        var details = event.target;
        if (!reduced || !details || !details.open || !details.matches || !details.matches('.collapsible-content details')) return;
        var root = details.closest('.shopify-section') || document;
        root.querySelectorAll('.collapsible-content details[open]').forEach(function (other) {
          if (other !== details) other.open = false;
        });
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    setRootVar(name, value) {
      const root = document.documentElement;
      if (root.style.getPropertyValue(name) === value) return;
      root.style.setProperty(name, value);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // Las alturas se miden cuando el navegador ya ha hecho el layout (ResizeObserver): sin forzar reflow al cargar.
      if ('ResizeObserver' in window) {
        this.heightObserver = new ResizeObserver(this.setHeaderHeight);
        if (this.header) this.heightObserver.observe(this.header);
        const announcementBar = document.querySelector('.announcement-bar-section');
        if (announcementBar) this.heightObserver.observe(announcementBar);
      } else {
        this.setHeaderHeight();
        window.addEventListener('load', this.setHeaderHeight, { once: true });
      }
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      this.currentScrollTop = 0;
      this.scrollAcc = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (!this.headerIsAlwaysSticky) {
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.createObserver();
      }
    }

    setHeaderHeight() {
      if (!this.header) return;
      // Primero se leen las dos alturas y después se escriben las variables (leer tras escribir fuerza otro reflow).
      const headerHeight = Math.round(this.header.offsetHeight);
      const announcement = document.querySelector('.announcement-bar-section');
      const announcementSticky = announcement && announcement.querySelector('.utility-bar--sticky');
      const announcementHeight = announcementSticky ? Math.round(announcement.offsetHeight) : 0;
      this.setRootVar('--header-height', `${headerHeight}px`);
      this.setRootVar('--hm-announcement-height', `${announcementHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      if (this.heightObserver) this.heightObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      const delta = scrollTop - this.currentScrollTop;
      this.currentScrollTop = scrollTop;
      this.scrollAcc += delta;

      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.scrollAcc = 0;
        requestAnimationFrame(this.reset.bind(this));
        return;
      }

      if (scrollTop <= this.headerBounds.bottom) return;

      if (this.scrollAcc > 12) {
        this.header.classList.add('scrolled-past-header');
        this.scrollAcc = 0;
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (this.scrollAcc < -12) {
        this.header.classList.add('scrolled-past-header');
        this.scrollAcc = 0;
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-imagen-desplegable"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 400;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clearAnim(content) {
      if (content._hmAccTimer) {
        clearTimeout(content._hmAccTimer);
        content._hmAccTimer = null;
      }
      if (content._hmAccEnd) {
        content.removeEventListener('transitionend', content._hmAccEnd);
        content.removeEventListener('transitioncancel', content._hmAccEnd);
        content._hmAccEnd = null;
      }
    }

    function afterHeight(content, done) {
      clearAnim(content);
      var finished = false;
      function complete(event) {
        if (event && event.target !== content) return;
        if (event && event.propertyName && event.propertyName !== 'height') return;
        if (finished) return;
        finished = true;
        clearAnim(content);
        done();
      }
      content._hmAccEnd = complete;
      content.addEventListener('transitionend', complete);
      content.addEventListener('transitioncancel', complete);
      content._hmAccTimer = setTimeout(function () {
        complete();
      }, DURATION + 80);
    }

    function resetPanel(content, details) {
      content.style.height = '';
      content.style.transition = '';
      details.classList.remove('is-animating');
    }

    function closeSiblings(details) {
      var root = details.closest('.hm-imgacc');
      if (!root) return;
      root.querySelectorAll('details').forEach(function (other) {
        if (other === details) return;
        var panel = other.querySelector('.hm-imgacc__panel');
        if (panel) closePanel(other, panel);
      });
    }

    function openPanel(details, content) {
      closeSiblings(details);
      clearAnim(content);
      details.classList.add('is-animating');
      details.open = true;
      var target = content.scrollHeight;
      if (!target) {
        resetPanel(content, details);
        return;
      }
      content.style.transition = 'none';
      content.style.height = '0px';
      void content.offsetHeight;
      content.style.transition = 'height ' + DURATION + 'ms ease';
      content.style.height = target + 'px';
      afterHeight(content, function () {
        resetPanel(content, details);
      });
    }

    function closePanel(details, content) {
      if (!details.open && !details.classList.contains('is-animating')) {
        resetPanel(content, details);
        return;
      }
      clearAnim(content);
      details.classList.add('is-animating');
      var start = content.offsetHeight || content.scrollHeight;
      if (!start) {
        details.open = false;
        resetPanel(content, details);
        return;
      }
      content.style.transition = 'none';
      content.style.height = start + 'px';
      void content.offsetHeight;
      content.style.transition = 'height ' + DURATION + 'ms ease';
      content.style.height = '0px';
      afterHeight(content, function () {
        details.open = false;
        resetPanel(content, details);
      });
    }

    function bind(details) {
      if (details.dataset.hmImgaccBound === 'true') return;
      details.dataset.hmImgaccBound = 'true';
      var summary = details.querySelector('summary');
      var content = details.querySelector('.hm-imgacc__panel');
      if (!summary || !content) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (reduced) {
          var willOpen = !details.open;
          if (willOpen) closeSiblings(details);
          details.open = willOpen;
          resetPanel(content, details);
          return;
        }
        if (details.open) closePanel(details, content);
        else openPanel(details, content);
      });
    }

    function init(root) {
      (root || document).querySelectorAll('.hm-imgacc details').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
